<div class="accessibility-container">
  <a class="accessibility-content-item" title="Cambiar contraste"
     aria-label="Cambiar contraste" (click)="cambiarContraste()">
    <img src="assets/img/svg/gov-icon-contrast.svg"
         alt="Accesibilidad contraste" class="accessibility-item"/>
  </a>
  <a class="accessibility-content-item" title="Disminuir fuente"
     aria-label="Disminuir fuente" (click)="disminuirFuente()">
    <img src="assets/img/svg/gov-icon-lilfont.svg"
         alt="Disminuir fuente" class="accessibility-item"/>
  </a>

  <a *ngIf="hasModifyFont" class="accessibility-content-item" title="Disminuir fuente"
     aria-label="Disminuir fuente" (click)="restablecerFuente()">
    <img src="assets/img/svg/gov-icon-resetfont.svg"
         alt="Restablecer fuente" class="accessibility-item"/>
  </a>
  <a class="accessibility-content-item" title="Aumentar fuente"
     aria-label="Aumentar fuente" (click)="aumentarFuente()">
    <img src="assets/img/svg/gov-icon-bigfont.svg"
         alt="Aumentar fuente" class="accessibility-item"/>
  </a>
</div>
